import { registerEnumType } from 'type-graphql'

export enum ReturnOrderActionEnum {
  Refunded = 'Refunded',
  Replaced = 'Replaced',
  SomePartsReplaced = 'SomePartsReplaced',
}

registerEnumType(ReturnOrderActionEnum, {
  name: 'ReturnOrderActionEnum',
  description: 'Derived overall action of a return order based on its line resolutions.',
})
